export default "__VITE_ASSET__K_057Go8__"